"use client";

import React, { FC, memo } from "react";
import { cn } from "utils";

interface SummaryProps {
  /** 标题 */
  title: string;
  /** 摘要内容 */
  summary: string;
  /** 自定义类名 */
  className?: string;
}

/**
 * Summary 摘要组件
 * 显示报告标题和摘要内容
 *
 * @param props SummaryProps
 * @returns React.ReactElement
 */
export const Summary: FC<SummaryProps> = memo(
  ({ title, summary, className }) => {
    return (
      <div className={cn("flex flex-col gap-2 md:gap-0.5", className)}>
        <h2
          aria-label="Summary h2"
          data-openreplay-label="Summary h2 Semantic"
          id="sem-summary-h2"
          className="title_l text-content_primary line-clamp-1"
        >
          {title}
        </h2>
        <p className="body_m text-content_secondary line-clamp-2">{summary}</p>
      </div>
    );
  },
);

Summary.displayName = "Summary";
